import { FormValidationService } from '../services/form-validation.service';

export function validateForm(blur = true) {
  return function decorator(_targetClass: any, _fnName: any, fn: any) {
    const origFn = fn.value;

    fn.value = async function decorated(ev: any, ...args: any[]) {
      const isValid = await FormValidationService.validateAllFields(
        ev.target,
        blur
      );
      if (isValid) {
        await origFn.call(this, ev, ...args);
      }
    };
    return fn;
  };
}
